var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "page__profile", attrs: { role: "main" } }, [
    _c("div", { staticClass: "o-wrapper" }, [
      _c("div", { staticClass: "o-grid" }, [
        _c(
          "aside",
          {
            staticClass:
              "profile__sidebar o-grid__item u-width-3/12 u-width-full@m",
          },
          [
            _c("div", { staticClass: "profile__sidebar__main" }, [
              _c(
                "ul",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        tag: "li",
                        to: "/contact",
                        "exact-active-class": "active",
                      },
                    },
                    [_c("a", [_vm._v("Contact")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        tag: "li",
                        to: "/faqs",
                        "exact-active-class": "active",
                      },
                    },
                    [_c("a", [_vm._v("FAQs")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        tag: "li",
                        to: "/terms",
                        "exact-active-class": "active",
                      },
                    },
                    [_c("a", [_vm._v("Terms & Conditions")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        tag: "li",
                        to: "/privacy",
                        "exact-active-class": "active",
                      },
                    },
                    [_c("a", [_vm._v("Privacy Policy")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        tag: "li",
                        to: "/cookies",
                        "exact-active-class": "active",
                      },
                    },
                    [_c("a", [_vm._v("Cookie Policy")])]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "u-width-1/12" }),
        _vm._v(" "),
        _c("div", { staticClass: "o-grid__item u-width-8/12 u-width-full@s" }, [
          _c("div", { staticClass: "o-grid__item u-width-full@m" }, [
            _c("div", { staticClass: "o-grid profile__content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "o-grid__item u-width-10/12 u-width-full@s u-m-b4",
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.success
                    ? _c("p", [
                        _vm._v(
                          "Thank you for your comments - we'll be in touch soon."
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors
                    ? _c("p", { staticClass: "error" }, [
                        _vm._v(
                          "There was an issue submitting the form - please see below."
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.success === false &&
                  _vm.errors === false &&
                  _vm.$root.user !== false
                    ? _c("p", [
                        _vm._v(
                          "Hey " +
                            _vm._s(_vm.$root.user.firstName) +
                            ", we'd love you to voice your opinion. Have a great idea for a new " +
                            _vm._s(_vm.$root.brand.name) +
                            " community? Or just have a general question about the company? Feel free to get in touch below and we'll get back to you as soon as possible."
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.success === false
                    ? _c(
                        "form",
                        { staticClass: "u-width-full u-m-t3" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-profile__input-group u-width-10/12 u-width-full@s",
                            },
                            [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v("Name"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.name,
                                    expression: "form.name",
                                  },
                                ],
                                ref: "name",
                                staticClass: "c-textbox u-width-full",
                                attrs: { id: "name" },
                                domProps: { value: _vm.form.name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.form,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.errors.name
                                ? _c("span", {
                                    staticClass: "u-error-asterix",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        Object.entries(_vm.errors.name).map(
                                          (item) => item[1]
                                        )[0]
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-profile__input-group u-width-10/12 u-width-full@s",
                            },
                            [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v("Email"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.email,
                                    expression: "form.email",
                                  },
                                ],
                                ref: "email",
                                staticClass: "c-textbox u-width-full",
                                attrs: { id: "email" },
                                domProps: { value: _vm.form.email },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.form,
                                      "email",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.errors.email
                                ? _c("span", {
                                    staticClass: "u-error-asterix",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        Object.entries(_vm.errors.email).map(
                                          (item) => item[1]
                                        )[0]
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-profile__input-group u-width-10/12 u-width-full@s",
                            },
                            [
                              _c("label", { attrs: { for: "comments" } }, [
                                _vm._v("Comments"),
                              ]),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.comments,
                                    expression: "form.comments",
                                  },
                                ],
                                ref: "comments",
                                staticClass:
                                  "c-textbox--contactus u-width-full",
                                attrs: { id: "comments" },
                                domProps: { value: _vm.form.comments },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.form,
                                      "comments",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.errors.comments
                                ? _c("span", {
                                    staticClass: "u-error-asterix",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        Object.entries(_vm.errors.comments).map(
                                          (item) => item[1]
                                        )[0]
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "c-btn u-text-small u-p-x3 u-p-y1",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submit.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("Submit")]
                          ),
                          _vm._v(" "),
                          _c("vue-recaptcha", {
                            ref: "invisRecaptcha",
                            attrs: {
                              size: "invisible",
                              badge: "bottomright",
                              loadRecaptchaScript: true,
                              sitekey: _vm.recaptchaSiteKey,
                            },
                            on: {
                              verify: _vm.recaptchaVerify,
                              expired: _vm.recaptchaExpired,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "o-grid u-m-t10 u-m-t5@s u-m-b2" }, [
                    _c("div", { staticClass: "o-grid__item u-width-half" }, [
                      _c("h4", [_vm._v("Address")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$root.brand.company)),
                        _c("br"),
                        _vm._v(
                          "\n                                            59 Mealough Road"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                            Belfast"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                            BT8 8LS"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                            N. Ireland"
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-profile__header" }, [
      _c("h1", { staticClass: "u-m-b5 u-m-b2@s" }, [_vm._v("Contact Us")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-profile__connect-social u-m-b6@s" }, [
      _c("h4", { staticClass: "u-m-t10 u-m-t3@s u-m-b2" }, [
        _vm._v("Connect on social"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-profile__connect-social-btns" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.facebook.com/dyadey",
              target: "_blank",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "img/icons/icon-facebook-article.svg",
                alt: "Connect via Facebook",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://twitter.com/dyadey_", target: "_blank" } },
          [
            _c("img", {
              attrs: {
                src: "img/icons/icon-twitter-article.svg",
                alt: "Connect via Twitter",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.instagram.com/dyadey/",
              target: "_blank",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "img/icons/icon-instagram-article.svg",
                alt: "Connect via Twitter",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.youtube.com/channel/UCUxyqxeim5H4ECqA4QFxVDg",
              target: "_blank",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "img/icons/icon-youtube-article.svg",
                alt: "Connect via YouTube",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: "mailto:info@dyadey.com" } }, [
          _c("img", {
            attrs: {
              src: "img/icons/icon-email-share-article.svg",
              alt: "Connect via email",
            },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }